import styled from 'styled-components';

export const StyledObjectLight = styled.div`
    width: 0%;
    height: 0%;
`;